import * as types from "./mutation_types"

export default {
    [types.RESET](state) {
        Object.assign(state, {
            isLoading: false,
            item: {},
            showMessage: false,
            message: "",
            isSuccess: false,
            params: {},



        })
    },
    [types.SET_FILTER](state, params) {
        Object.assign(state, { params })
    },
    [types.SET_TOGGLE_LOADING](state) {
        Object.assign(state, { isLoading: !state.isLoading })
    },
    [types.SET_SHOW_LOADING](state) {
        Object.assign(state, { isLoading: true })
    },
    [types.SET_HIDE_LOADING](state) {
        Object.assign(state, { isLoading: false })
    },
    [types.SET_TOGGLE_MESSAGE](state) {
        Object.assign(state, { showMessage: !state.showMessage })
    },
    [types.SET_SHOW_MESSAGE](state) {
        Object.assign(state, { showMessage: true })
    },
    [types.SET_HIDE_MESSAGE](state) {
        Object.assign(state, { showMessage: false })
    },

    [types.SET_IS_SUCCESS](state) {
        Object.assign(state, { isSuccess: true })
    },
    [types.SET_IS_ERROR](state) {
        Object.assign(state, { isSuccess: false })
    },
    [types.SET_MESSAGE](state, message) {
        Object.assign(state, { message })
    },
    [types.SET_ITEMS](state, item) {
        Object.assign(state, { item })
    },

}